export default __webpack_public_path__ + "static/media/July2012.d27a0dd7.png";